import { render, staticRenderFns } from "./complaintComment.vue?vue&type=template&id=625861e5&scoped=true&"
import script from "./complaintComment.vue?vue&type=script&lang=js&"
export * from "./complaintComment.vue?vue&type=script&lang=js&"
import style0 from "./complaintComment.vue?vue&type=style&index=0&id=625861e5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625861e5",
  null
  
)

component.options.__file = "complaintComment.vue"
export default component.exports